import { Component } from "@angular/core";
import { RA_CONFIG } from "../../shared/ra.config";
import { LogoComponent } from "../../shared/components/logo.component";

@Component({
  selector: "wat-no-role-access",
  standalone: true,
  imports: [LogoComponent],
  template: `
    <main class="no-access">
        <svg
          class="waves absolute-custom"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>

          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="0"
              fill="var(--wave-color)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.2)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="7"
              fill="#fff0"
            />
          </g>
        </svg>
        <section class="no-access__content">
        <ui-ng-logo [logo]="logo"></ui-ng-logo>
        <h1 class="no-access__title">Access Restricted</h1>
        <p class="no-access__subtitle">Your account doesn't have permission to access this application.</p>
        <p class="no-access__text">
          A role must be assigned before you can continue. 
          Contact your administrator to request access.
        </p>
        <span class="no-access__badge pi pi-lock"></span>
      </section>
    </main>
  `,
  styles: `
    :host {
      --primary-color-with-opacity: 170, 29, 19;
      display: block;
    }

    .no-access {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      min-height: 100svh;
      padding: 10vh 2rem 4rem;
      overflow: hidden;
    }

    .no-access::before {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 1;
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
      background:
        radial-gradient(
          circle at 15% 20%,
          rgba(var(--primary-color-with-opacity), .05),
          transparent 35%
        ),
        radial-gradient(
          circle at 85% 70%,
          rgba(var(--primary-color-with-opacity), .035),
          transparent 45%
        );
      pointer-events: none;
    }

    .waves {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 35vh;
      min-height: 100px;
      z-index: 0;
      pointer-events: none;
    }

    .no-access__content {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      width: 100%;
      max-width: 36rem;
      text-align: center;
    }

    .no-access__badge {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.5rem;
      height: 4.5rem;
      border-radius: 50%;
      font-size: 1.9rem;
      color: var(--primary_color);
      background: rgba(var(--primary-color-with-opacity), .08);
      border: 1px solid rgba(var(--primary-color-with-opacity), .2);
      animation: badge-pulse 3.5s ease-in-out infinite;
    }

    @keyframes badge-pulse {
      0%,
      100% {
        box-shadow: 0 0 0 0 rgba(var(--primary-color-with-opacity), .25);
      }
      50% {
        box-shadow: 0 0 0 16px rgba(var(--primary-color-with-opacity), 0);
      }
    }

    .no-access__title {
      margin: 0;
      font-size: clamp(2.5rem, 5vw, 3rem);
      font-weight: 400;
      line-height: 1.1;
      letter-spacing: -.025em;
      color: var(--primary-color);
    }

    .no-access__subtitle {
      margin: 0;
      font-size: 2.25rem;
      font-weight: 600;
      line-height: 1.5;
      color: var(--title-home);
      opacity: .95;
    }

    .no-access__text {
      margin: 0;
      max-width: 34rem;
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 1.75;
      color: var(--surface-900);
    }

    .parallax > use {
      animation: move-forever 75s cubic-bezier(.55,.5,.45,.5)     infinite;
    }
    .parallax > use:nth-child(1) {
      animation-delay: -2s;
      animation-duration: 50s;
    }
    .parallax > use:nth-child(2) {
      animation-delay: -3s;
      animation-duration: 54s;
    }
    .parallax > use:nth-child(3) {
      animation-delay: -4s;
      animation-duration: 61s;
    }
    .parallax > use:nth-child(4) {
      animation-delay: -5s;
      animation-duration: 67s;
    }
    @keyframes move-forever {
      0% {
      transform: translate3d(-90px,0,0);
      }
      100% { 
        transform: translate3d(85px,0,0);
      }
    }
  `
})
export class NoRoleAccessComponent {
  readonly logo = {
  ...RA_CONFIG.logo,
  width: 170,
  height: 170,
  imgUrl: {
    url: '../../../assets/images/Athena_logo/LOGO_Athena_RED.svg'
  }
};
}